import React from "react";
import "../styles/Footer.css";

const Footer = () => {
  return (
    <footer>
      <h5>©Tous droits réservés</h5>
    </footer>
  );
};

export default Footer;
